import React from "react";
import { Tooltip } from "@mui/material";
import ReactSwitch from "react-switch";
import { CheckboxIcon, PencilIcon } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { toast } from "react-toastify";

import { setDefaultSetting, setIsLoading, store } from "../store";
import { store as globalStore } from "@components/VerticalLayout/store";

import { editPayment } from "./helper";
import { useFetchGlobal } from "../../../../../api/hooks";
import { useSyncIsSupported } from "./hooks";

export function CustomIcons({
    e,
    setRowData,
    setIsAddPaymentClicked,
    setDataIsUpdated,
    dataIsUpdated,
}: any): JSX.Element {
    const { fetchGlobal } = useFetchGlobal();
    const { t } = useTranslation();
    const { franchiseID } = useSnapshot(globalStore);
    const { defaultSetting, isLoading } = useSnapshot(store);
    const [isSupported, setIsSupported] = React.useState(false);
    const handlePencilClick = () => {
        setRowData(e.selectedRow);
        setIsAddPaymentClicked(true);
    };

    const handleSwitchChange = async (isChecked: boolean) => {
        setIsLoading(true);
        const updatedPayment = defaultSetting.paymentMethod?.data?.map(
            (row: any) => {
                if (row.Id === e.selectedRow.Id) {
                    return { ...row, isActive: isChecked };
                }
                return row;
            }
        );
        editPayment(
            franchiseID,
            updatedPayment,
            setIsAddPaymentClicked,
            setDataIsUpdated,
            dataIsUpdated,
            fetchGlobal
        );
        toast.success(
            `${t(
                isChecked
                    ? "Payment method has been successfully activated"
                    : "Payment method has been successfully deactivated"
            )}`,
            {
                position: toast.POSITION.TOP_CENTER,
                theme: "colored",
                icon: <CheckboxIcon height={25} width={25} fill="white" />,
            }
        );
        setDefaultSetting({
            ...defaultSetting,
            paymentMethod: { data: [...updatedPayment] },
        });
    };

    useSyncIsSupported(
        defaultSetting,
        e.selectedRow.support_vente,
        setIsSupported
    );
    return (
        <div className="d-flex justify-content-around">
            <Tooltip
                title={
                    !isSupported
                        ? ""
                        : e.selectedRow.isActive === false
                        ? t("Activate")
                        : t("Unactivate")
                }
                arrow
            >
                <div>
                    <ReactSwitch
                        uncheckedIcon={false}
                        checkedIcon={false}
                        handleDiameter={26}
                        offColor="#f7b4b8"
                        offHandleColor="#E30613"
                        onColor="#c2eddd"
                        onHandleColor="#34C38F"
                        width={50}
                        height={20}
                        checked={e.selectedRow.isActive}
                        onChange={() =>
                            handleSwitchChange(!e.selectedRow.isActive)
                        }
                        disabled={!isSupported || isLoading === true}
                    />
                </div>
            </Tooltip>

            <div className="ml-3">
                <Tooltip title={t("To modify")} arrow>
                    <div>
                        <PencilIcon
                            onClick={handlePencilClick}
                            height={25}
                            width={25}
                            style={{ cursor: "pointer" }}
                        />
                    </div>
                </Tooltip>
            </div>
        </div>
    );
}
